<template>
  <router-view></router-view>
</template>
<script type="text/javascript">
export default {
  name: 'Calendar'
}

</script>



// WEBPACK FOOTER //
// src/Crm/containers/Calendar.vue